import { IThunkActionCreator } from '../../types/thunk';
import { resolveUserRole } from '../../services/userRole';
import { TUserRole } from '../../types/currentUser';
import { setUserRole } from './actions';

export function getUserRoleAction(): IThunkActionCreator<Promise<TUserRole>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger, config } = context;
    const userRole = await resolveUserRole({ config, httpApi, logger });
    dispatch(setUserRole(userRole));

    return userRole;
  };
}
